var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFamily(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 390,
    height: 615,
    viewBox: "0 0 390 615",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_3046)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 195,
    cy: 510.5,
    rx: 392,
    ry: 91.5,
    fill: "url(#paint0_linear_47_3046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.61 485.838V462H242.72V485.838L264 497.757V511H131V497.757L153.61 485.838Z",
    fill: "#086135",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113.986,
    y: 407.063,
    width: 159.855,
    height: 27.8009,
    fill: "#CF3E39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.143 160L147 285H260L238.092 160H163.143Z",
    fill: "#CF3E39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164.955,
    y: 112.837,
    width: 74.1357,
    height: 44.0181,
    fill: "#B75854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.138 144.113V115.154L163.979 108.204C157.415 117.471 144.75 139.48 146.604 153.38C148.457 167.281 160.504 168.439 166.296 167.281C162.435 169.211 165.138 183.498 172.088 188.131C187.393 198.334 196.414 190.062 199.889 183.498C202.206 188.517 209.851 197.167 221.898 191.606C233.945 186.046 235.412 173.072 234.64 167.281C241.976 168.439 256.186 166.817 254.332 151.063C252.479 135.309 241.204 117.471 235.798 110.52C236.185 120.173 236.03 141.565 232.323 149.905C228.617 158.245 218.423 154.925 213.789 152.222C203.364 147.588 201.047 144.113 185.988 152.222C171.393 160.081 165.91 149.905 165.138 144.113Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.307 47.9407L159.534 115.32C158.412 117.32 159.858 119.787 162.15 119.787H238.718C241.026 119.787 242.47 117.29 241.318 115.29L202.524 47.9108C201.362 45.8934 198.445 45.9101 197.307 47.9407Z",
    fill: "#FFD04D",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.537 31.6701L203.644 21.5332C202.885 18.8727 199.115 18.8727 198.356 21.5331L195.463 31.6701C195.278 32.3188 194.611 32.7036 193.957 32.5395L183.731 29.9764C181.048 29.3038 179.163 32.569 181.087 34.5567L188.419 42.1305C188.889 42.6152 188.889 43.3848 188.419 43.8694L181.087 51.4433C179.163 53.431 181.048 56.6962 183.731 56.0236L193.957 53.4605C194.611 53.2964 195.278 53.6812 195.463 54.3299L198.356 64.4668C199.115 67.1273 202.885 67.1273 203.644 64.4669L206.537 54.3299C206.722 53.6812 207.389 53.2964 208.043 53.4605L218.269 56.0236C220.952 56.6962 222.837 53.431 220.913 51.4433L213.581 43.8695C213.111 43.3848 213.111 42.6152 213.581 42.1306L220.913 34.5567C222.837 32.569 220.952 29.3038 218.269 29.9764L208.043 32.5395C207.389 32.7036 206.722 32.3188 206.537 31.6701Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 184.647,
    cy: 132.529,
    r: 5.79186,
    fill: "#2E2D1F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 212.448,
    cy: 132.529,
    r: 5.79186,
    fill: "#2E2D1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.339 149.905C204.339 151.441 203.729 152.914 202.643 154C201.557 155.087 200.084 155.697 198.548 155.697C197.011 155.697 195.538 155.087 194.452 154C193.366 152.914 192.756 151.441 192.756 149.905L196.276 150.609C197.775 150.909 199.32 150.909 200.819 150.609L204.339 149.905Z",
    fill: "#B75854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.401 290.068L198.183 368.837H311.704L289.695 290.068H214.401Z",
    fill: "#CF3E39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.167 273.851L216.717 244.891L215.559 237.941C208.995 247.208 196.33 269.217 198.183 283.118C200.037 297.018 212.084 298.176 217.876 297.018C214.014 298.949 216.717 313.235 223.667 317.869C238.973 328.072 247.993 319.799 251.468 313.235C253.785 318.255 261.43 326.904 273.477 321.344C285.524 315.784 286.992 302.81 286.219 297.018C293.556 298.176 307.765 296.555 305.912 280.801C304.058 265.047 292.784 247.208 287.378 240.258C287.764 249.911 285.051 272.461 281.344 280.801C277.646 289.121 270.039 284.683 265.402 281.979L265.369 281.959C254.943 277.326 252.627 273.851 237.568 281.959C222.972 289.819 221.94 279.643 221.167 273.851Z",
    fill: "#FFD04D",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.026 179.214L211.948 243.569C210.453 246.235 212.38 249.525 215.437 249.525H288.568C291.645 249.525 293.57 246.196 292.034 243.529L254.981 179.174C253.433 176.484 249.543 176.506 248.026 179.214Z",
    fill: "#FF7300",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.443,
    cy: 174.231,
    r: 14.3088,
    fill: "#FFD04D",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.094 249.75H287.594V262C287.594 281.468 271.812 297.25 252.344 297.25C232.876 297.25 217.094 281.468 217.094 262V249.75Z",
    fill: "#B75854",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.586 290.068L86.3687 368.837H199.889L177.88 290.068H102.586Z",
    fill: "#CF3E39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.719,
    y: 242.575,
    width: 74.1357,
    height: 44.0181,
    fill: "#B75854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.903 273.851V244.891L103.744 237.941C97.1802 247.208 84.5154 269.217 86.3688 283.118C88.2222 297.018 100.269 298.176 106.061 297.018C102.2 298.949 104.902 313.235 111.853 317.869C127.158 328.072 136.179 319.799 139.654 313.235C141.971 318.255 149.616 326.904 161.663 321.344C173.71 315.784 175.177 302.81 174.405 297.018C181.741 298.176 195.951 296.555 194.097 280.801C192.244 265.047 180.969 247.208 175.563 240.258C175.949 249.911 175.795 271.302 172.088 279.643C168.381 287.983 158.188 284.662 153.554 281.959C143.129 277.326 140.812 273.851 125.753 281.959C111.158 289.819 105.675 279.643 104.903 273.851Z",
    fill: "#FFD04D",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.211 179.214L100.133 243.569C98.6382 246.235 100.565 249.525 103.622 249.525H176.753C179.83 249.525 181.755 246.196 180.22 243.529L143.167 179.174C141.618 176.484 137.729 176.506 136.211 179.214Z",
    fill: "#FF7300",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124.412,
    cy: 262.267,
    r: 5.79186,
    fill: "#2E2D1F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.213,
    cy: 262.267,
    r: 5.79186,
    fill: "#2E2D1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.104 281C144.104 282.536 143.494 284.009 142.408 285.095C141.321 286.182 139.848 286.792 138.312 286.792C136.776 286.792 135.303 286.182 134.217 285.095C133.131 284.009 132.52 282.536 132.52 281L136.04 281.704C137.54 282.004 139.084 282.004 140.584 281.704L144.104 281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.629,
    cy: 174.231,
    r: 14.3088,
    fill: "#FFD04D",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.869 270.375C262.869 271.592 262.569 272.797 261.987 273.922C261.405 275.046 260.552 276.068 259.476 276.928C258.4 277.789 257.123 278.471 255.718 278.937C254.313 279.403 252.806 279.642 251.285 279.642C249.764 279.642 248.258 279.403 246.852 278.937C245.447 278.471 244.17 277.789 243.094 276.928C242.019 276.068 241.165 275.046 240.583 273.922C240.001 272.797 239.701 271.592 239.701 270.375L251.285 270.375H262.869Z",
    fill: "#2E2D1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.285 270.375C251.285 271.592 250.985 272.797 250.403 273.922C249.821 275.046 248.968 276.068 247.892 276.928C246.817 277.789 245.54 278.471 244.134 278.937C242.729 279.403 241.223 279.642 239.701 279.642C238.18 279.642 236.674 279.403 235.268 278.937C233.863 278.471 232.586 277.789 231.51 276.928C230.435 276.068 229.582 275.046 228.999 273.922C228.417 272.797 228.118 271.592 228.118 270.375L239.701 270.375H251.285Z",
    fill: "#FFD04D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.452 270.375C274.452 271.592 274.153 272.797 273.571 273.922C272.988 275.046 272.135 276.068 271.06 276.928C269.984 277.789 268.707 278.471 267.302 278.937C265.896 279.403 264.39 279.642 262.869 279.642C261.347 279.642 259.841 279.403 258.436 278.937C257.03 278.471 255.753 277.789 254.678 276.928C253.602 276.068 252.749 275.046 252.167 273.922C251.585 272.797 251.285 271.592 251.285 270.375L262.869 270.375H274.452Z",
    fill: "#FFD04D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 138.312,
    cy: 343.353,
    r: 12.7421,
    fill: "#005B2E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.443,
    cy: 343.353,
    r: 12.7421,
    fill: "#005B2E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.1855,
    y: 367.679,
    width: 113.52,
    height: 30.1176,
    fill: "#FFD04D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198,
    y: 367.679,
    width: 113.52,
    height: 30.1176,
    fill: "#FFD04D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4005 394.321L19.1833 473.091H132.704L110.695 394.321H35.4005Z",
    fill: "#CF3E39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.1674 378.104L37.7172 349.145L36.5588 342.195C29.9947 351.462 17.3298 373.471 19.1832 387.371C21.0366 401.272 33.0837 402.43 38.8755 401.272C35.0143 403.202 37.7169 417.489 44.6674 422.122C59.9726 432.325 68.9932 424.053 72.4683 417.489C74.785 422.508 82.4303 431.157 94.4773 425.597C106.524 420.037 107.992 407.063 107.219 401.272C114.556 402.43 128.765 400.808 126.912 385.054C125.058 369.3 113.784 351.462 108.378 344.511C108.764 354.164 104.707 376.714 101 385.054C97.2932 393.395 91.0022 388.916 86.3687 386.213C75.9434 381.579 73.6267 378.104 58.5678 386.213C43.972 394.072 42.9397 383.896 42.1674 378.104Z",
    fill: "#F8F8F8",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0256 283.467L32.9476 347.822C31.4529 350.489 33.38 353.778 36.4367 353.778H109.568C112.645 353.778 114.57 350.449 113.034 347.782L75.9812 283.427C74.4325 280.737 70.5434 280.759 69.0256 283.467Z",
    fill: "#FFD04D",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 71.0588,
    cy: 278.059,
    r: 14.3088,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2839 354.528H108.603V366.52C108.603 385.938 92.8615 401.68 73.4434 401.68C54.0254 401.68 38.2839 385.938 38.2839 366.52V354.528Z",
    fill: "#B75854",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 57.2264,
    cy: 366.52,
    r: 5.79186,
    fill: "#2E2D1F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 85.0272,
    cy: 366.52,
    r: 5.79186,
    fill: "#2E2D1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8688 374.629C83.8688 375.846 83.5692 377.051 82.9871 378.175C82.4049 379.3 81.5517 380.321 80.476 381.182C79.4004 382.042 78.1234 382.725 76.718 383.19C75.3126 383.656 73.8063 383.896 72.2851 383.896C70.7639 383.896 69.2576 383.656 67.8522 383.19C66.4468 382.725 65.1699 382.042 64.0942 381.182C63.0186 380.321 62.1653 379.3 61.5832 378.175C61.001 377.051 60.7014 375.846 60.7014 374.629L72.2851 374.629H83.8688Z",
    fill: "#2E2D1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2851 374.629C72.2851 375.846 71.9855 377.051 71.4033 378.175C70.8212 379.3 69.968 380.321 68.8923 381.182C67.8167 382.042 66.5397 382.725 65.1343 383.19C63.7289 383.656 62.2226 383.896 60.7014 383.896C59.1802 383.896 57.6739 383.656 56.2685 383.19C54.8631 382.725 53.5861 382.042 52.5105 381.182C51.4348 380.321 50.5816 379.3 49.9994 378.175C49.4173 377.051 49.1177 375.846 49.1177 374.629L60.7014 374.629H72.2851Z",
    fill: "#FFD04D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4526 374.629C95.4526 375.846 95.153 377.051 94.5708 378.175C93.9887 379.3 93.1354 380.321 92.0598 381.182C90.9841 382.042 89.7072 382.725 88.3018 383.19C86.8964 383.656 85.3901 383.896 83.8689 383.896C82.3477 383.896 80.8414 383.656 79.436 383.19C78.0306 382.725 76.7536 382.042 75.6779 381.182C74.6023 380.321 73.749 379.3 73.1669 378.175C72.5848 377.051 72.2852 375.846 72.2852 374.629L83.8689 374.629H95.4526Z",
    fill: "#FFD04D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.025 394.321L257.808 473.091H371.328L349.319 394.321H274.025Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.792 378.104L276.341 349.145L275.183 342.195C268.619 351.462 255.954 373.471 257.807 387.371C259.661 401.272 271.708 402.43 277.5 401.272C273.639 403.202 276.341 417.489 283.292 422.122C298.597 432.325 307.617 424.053 311.093 417.489C313.409 422.508 321.055 431.157 333.102 425.597C345.149 420.037 346.616 407.063 345.844 401.272C353.18 402.43 367.389 400.808 365.536 385.054C363.683 369.3 352.408 351.462 347.002 344.511C347.388 354.164 347.234 375.556 343.527 383.896C339.82 392.236 329.626 388.916 324.993 386.213C314.568 381.579 312.251 378.104 297.192 386.213C282.596 394.072 281.564 383.896 280.792 378.104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.068,
    cy: 278.484,
    r: 15.0588,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.158 353.778H347.977V366.52C347.977 386.353 331.9 402.43 312.068 402.43V402.43C292.236 402.43 276.158 386.353 276.158 366.52V353.778Z",
    fill: "#B75854"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 295.851,
    cy: 366.52,
    r: 5.79186,
    fill: "#2E2D1F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.651,
    cy: 366.52,
    r: 5.79186,
    fill: "#2E2D1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.493 374.629C322.493 375.846 322.193 377.051 321.611 378.175C321.029 379.3 320.176 380.321 319.1 381.182C318.025 382.042 316.748 382.725 315.342 383.19C313.937 383.656 312.431 383.896 310.909 383.896C309.388 383.896 307.882 383.656 306.476 383.19C305.071 382.725 303.794 382.042 302.718 381.182C301.643 380.321 300.79 379.3 300.207 378.175C299.625 377.051 299.326 375.846 299.326 374.629L310.909 374.629H322.493Z",
    fill: "#2E2D1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.909 374.629C310.909 375.846 310.61 377.051 310.028 378.175C309.445 379.3 308.592 380.321 307.517 381.182C306.441 382.042 305.164 382.725 303.759 383.19C302.353 383.656 300.847 383.896 299.326 383.896C297.804 383.896 296.298 383.656 294.893 383.19C293.487 382.725 292.21 382.042 291.135 381.182C290.059 380.321 289.206 379.3 288.624 378.175C288.042 377.051 287.742 375.846 287.742 374.629L299.326 374.629H310.909Z",
    fill: "#FFD04D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.077 374.629C334.077 375.846 333.777 377.051 333.195 378.175C332.613 379.3 331.76 380.321 330.684 381.182C329.608 382.042 328.331 382.725 326.926 383.19C325.521 383.656 324.014 383.896 322.493 383.896C320.972 383.896 319.466 383.656 318.06 383.19C316.655 382.725 315.378 382.042 314.302 381.182C313.227 380.321 312.373 379.3 311.791 378.175C311.209 377.051 310.909 375.846 310.909 374.629L322.493 374.629H334.077Z",
    fill: "#FFD04D"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.068,
    cy: 447.606,
    r: 12.7421,
    fill: "#337052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.025 394.321L257.808 473.091H314.568H371.328L349.319 394.321H274.025Z",
    fill: "#CF3E39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.792 378.104L276.341 349.145L275.183 342.195C268.619 351.462 255.954 373.471 257.807 387.371C259.661 401.272 271.708 402.43 277.5 401.272C273.639 403.202 276.341 417.489 283.292 422.122C298.597 432.325 307.617 424.053 311.093 417.489C313.409 422.508 321.055 431.157 333.102 425.597C345.149 420.037 346.616 407.063 345.844 401.272C353.18 402.43 367.389 400.808 365.536 385.054C363.683 369.3 352.408 351.462 347.002 344.511C347.388 354.164 342.707 373.16 339 381.5C335.293 389.84 329.626 388.916 324.993 386.213C314.568 381.579 312.251 378.104 297.192 386.213C282.596 394.072 281.564 383.896 280.792 378.104Z",
    fill: "#F8F8F8",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.65 283.467L271.572 347.822C270.077 350.489 272.004 353.778 275.061 353.778H348.192C351.269 353.778 353.194 350.449 351.659 347.782L314.605 283.427C313.057 280.737 309.168 280.759 307.65 283.467Z",
    fill: "#FFD04D",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 312.068,
    cy: 278.484,
    r: 14.3088,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.75 354.75H347.25V366C347.25 385.468 331.468 401.25 312 401.25C292.532 401.25 276.75 385.468 276.75 366V354.75Z",
    fill: "#B75854",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 295.851,
    cy: 366.52,
    r: 5.79186,
    fill: "#2E2D1F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 323.651,
    cy: 366.52,
    r: 5.79186,
    fill: "#2E2D1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.543 374.629C315.543 375.237 315.393 375.84 315.102 376.402C314.811 376.964 314.384 377.475 313.847 377.905C313.309 378.336 312.67 378.677 311.968 378.91C311.265 379.143 310.512 379.262 309.751 379.262C308.99 379.262 308.237 379.143 307.535 378.91C306.832 378.677 306.193 378.336 305.656 377.905C305.118 377.475 304.691 376.964 304.4 376.402C304.109 375.84 303.959 375.237 303.959 374.629L309.751 374.629H315.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.871 394.321L139.654 473.091H253.174L231.165 394.321H155.871Z",
    fill: "#CF3E39"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.914,
    cy: 447.606,
    r: 12.7421,
    fill: "#FFD04D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.188,
    y: 346.828,
    width: 76.4525,
    height: 44.0181,
    fill: "#B75854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.188 378.104V349.145L157.029 342.195C150.465 351.462 137.8 373.471 139.654 387.371C141.507 401.272 153.554 402.43 159.346 401.272C155.485 403.202 158.187 417.489 165.138 422.122C180.443 432.325 189.464 424.053 192.939 417.489C195.255 422.508 202.901 431.157 214.948 425.597C226.995 420.037 228.462 407.063 227.69 401.272C235.026 402.43 249.236 400.808 247.382 385.054C245.529 369.3 234.254 351.462 228.848 344.511C229.234 354.164 229.08 375.556 225.373 383.896C221.666 392.236 211.473 388.916 206.839 386.213C196.414 381.579 194.097 378.104 179.038 386.213C164.442 394.072 158.96 383.896 158.188 378.104Z",
    fill: "#F8F8F8",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.496 283.467L153.418 347.822C151.923 350.489 153.85 353.778 156.907 353.778H230.038C233.115 353.778 235.04 350.449 233.505 347.782L196.452 283.427C194.903 280.737 191.014 280.759 189.496 283.467Z",
    fill: "#FFD04D",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 193.914,
    cy: 278.484,
    r: 14.3088,
    fill: "white",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.697,
    cy: 366.52,
    r: 5.79186,
    fill: "#2E2D1F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.498,
    cy: 366.52,
    r: 5.79186,
    fill: "#2E2D1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.389 383.896C197.389 385.432 196.779 386.905 195.693 387.991C194.607 389.078 193.133 389.688 191.597 389.688C190.061 389.688 188.588 389.078 187.502 387.991C186.416 386.905 185.805 385.432 185.805 383.896L189.326 384.6C190.825 384.9 192.369 384.9 193.869 384.6L197.389 383.896Z",
    fill: "#2E2D1F"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.275,
    y: 433.297,
    width: 74.9525,
    height: 74.9525,
    fill: "#FF7300",
    stroke: "black",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273,
    y: 461,
    width: 73,
    height: 13,
    fill: "#FFD04D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 434,
    width: 73,
    height: 13,
    transform: "rotate(90 315 434)",
    fill: "#FFD04D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.293 577.332L313.728 570.626L320.45 573.089L316.363 581.071C314.473 581.183 308.884 578.415 306.325 577.016L312.293 577.332Z",
    fill: "#5F948E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.16 578.392L329.917 573.956L336.4 570.919L339.186 579.443C337.935 580.863 334.33 581.787 331.535 582.618L333.16 578.392Z",
    fill: "#5F948E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 339.012,
    cy: 508.501,
    r: 5.20119,
    stroke: "#DEA359",
    strokeWidth: 2.60059
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.018 549.786C367.878 530.021 353.857 520.312 346.488 517.929C336.866 513.247 323.191 513.594 317.557 514.353C300.328 517.278 287.975 529.956 287.325 543.609C286.675 557.262 299.678 566.69 310.405 569.94C315.11 571.366 318.727 574.159 321.267 576.928C322.921 578.73 327.125 578.361 328.786 576.565C334.158 570.754 343.289 571.262 349.414 568.965C357.216 566.039 362.092 562.139 365.018 549.786Z",
    fill: "#FFD04D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.838 514.678C340.897 511.817 333.594 510.885 330.56 510.777L328.609 514.678C332.51 516.758 341.937 518.904 345.838 519.554C345.796 517.904 345.737 514.62 345.838 514.678Z",
    fill: "#BF584D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.83 518.579C318.532 517.279 341.613 518.579 362.092 532.882",
    stroke: "#BF584D",
    strokeWidth: 1.3003,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.353 523.455C311.882 521.959 343.743 524.553 365.668 541.009",
    stroke: "#BF584D",
    strokeWidth: 1.3003,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.024 543.688C293.454 541.592 304.192 536.026 303.706 530.531C303.098 523.662 296.921 529.564 297.329 534.095C297.655 537.72 299.462 542.875 300.324 544.999C301.115 546.452 302.649 550.202 302.468 553.578C302.242 557.798 300.207 559.317 299.627 557.983C299.048 556.65 298.266 553.027 304.045 548.454C309.825 543.881 314.607 545.766 321.894 537.368C327.724 530.649 325.503 528.772 323.663 528.673C321.669 529.434 318.492 532.823 321.738 540.289C325.794 549.622 330.042 555.384 327.543 559.482C325.045 563.58 319.173 557.731 324.918 553.807C330.663 549.883 333.326 552.129 342.628 545.317C346.355 542.587 345.711 538.429 343.284 539.167C342.696 540.004 342.132 542.426 344.575 545.422C347.63 549.167 355.019 557.051 352.144 562.105C349.268 567.159 344.364 567.547 345.327 561.739C346.29 555.931 359.403 548.171 364.921 548.467",
    stroke: "#BF584D",
    strokeWidth: 1.3003,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.554 567.34C312.031 570.157 329 574.947 337.061 571.566M319.182 574.491C321.241 575.575 326.204 577.352 329.585 575.792",
    stroke: "#BF584D",
    strokeWidth: 0.650148
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.344,
    cy: 261,
    r: 7.53778,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.924445
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297,
    cy: 367,
    r: 7.53778,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.924445
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179,
    cy: 367,
    r: 7.53778,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.924445
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 125,
    cy: 262,
    r: 7.53778,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.924445
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 366,
    r: 7.53778,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.924445
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 133,
    r: 7.53778,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.924445
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.344,
    cy: 261,
    r: 7.53778,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.924445
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 324,
    cy: 367,
    r: 7.53778,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.924445
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 367,
    r: 7.53778,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.924445
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 262,
    r: 7.53778,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.924445
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 87,
    cy: 366,
    r: 7.53778,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.924445
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 213,
    cy: 133,
    r: 7.53778,
    fill: "white",
    stroke: "black",
    strokeWidth: 0.924445
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.596 266.417C235.05 266.18 237.778 263.304 237.778 259.79C237.778 257.19 236.284 254.939 234.108 253.848C231.376 255.087 229.475 257.839 229.475 261.035C229.475 263.115 230.28 265.007 231.596 266.417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M291.252 372.417C294.706 372.18 297.434 369.304 297.434 365.79C297.434 363.19 295.94 360.939 293.764 359.848C291.032 361.087 289.131 363.839 289.131 367.035C289.131 369.115 289.936 371.007 291.252 372.417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M173.252 372.417C176.706 372.18 179.434 369.304 179.434 365.79C179.434 363.19 177.94 360.939 175.764 359.848C173.032 361.087 171.131 363.839 171.131 367.035C171.131 369.115 171.936 371.007 173.252 372.417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.252 267.417C122.706 267.18 125.434 264.304 125.434 260.79C125.434 258.19 123.94 255.939 121.764 254.848C119.032 256.087 117.131 258.839 117.131 262.035C117.131 264.115 117.936 266.007 119.252 267.417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.2516 371.417C57.7056 371.18 60.4341 368.304 60.4341 364.79C60.4341 362.19 58.9403 359.939 56.7642 358.848C54.0316 360.087 52.131 362.839 52.131 366.035C52.131 368.115 52.9361 370.007 54.2516 371.417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.252 138.417C183.706 138.18 186.434 135.304 186.434 131.79C186.434 129.19 184.94 126.939 182.764 125.848C180.032 127.087 178.131 129.839 178.131 133.035C178.131 135.115 178.936 137.007 180.252 138.417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.596 266.417C262.05 266.18 264.778 263.304 264.778 259.79C264.778 257.19 263.284 254.939 261.108 253.848C258.376 255.087 256.475 257.839 256.475 261.035C256.475 263.115 257.28 265.007 258.596 266.417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M318.252 372.417C321.706 372.18 324.434 369.304 324.434 365.79C324.434 363.19 322.94 360.939 320.764 359.848C318.032 361.087 316.131 363.839 316.131 367.035C316.131 369.115 316.936 371.007 318.252 372.417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.252 372.417C203.706 372.18 206.434 369.304 206.434 365.79C206.434 363.19 204.94 360.939 202.764 359.848C200.032 361.087 198.131 363.839 198.131 367.035C198.131 369.115 198.936 371.007 200.252 372.417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.252 267.417C149.706 267.18 152.434 264.304 152.434 260.79C152.434 258.19 150.94 255.939 148.764 254.848C146.032 256.087 144.131 258.839 144.131 262.035C144.131 264.115 144.936 266.007 146.252 267.417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.2516 371.417C84.7056 371.18 87.4341 368.304 87.4341 364.79C87.4341 362.19 85.9403 359.939 83.7642 358.848C81.0316 360.087 79.131 362.839 79.131 366.035C79.131 368.115 79.9361 370.007 81.2516 371.417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.252 138.417C210.706 138.18 213.434 135.304 213.434 131.79C213.434 129.19 211.94 126.939 209.764 125.848C207.032 127.087 205.131 129.839 205.131 133.035C205.131 135.115 205.936 137.007 207.252 138.417Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-105-inside-1_47_3046",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.266 265.744C232.554 263.966 234.657 262.822 237.019 262.856C239.618 262.892 241.865 264.345 243.036 266.468C241.662 268.083 239.605 269.096 237.319 269.064C234.782 269.028 232.563 267.714 231.266 265.744Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.266 265.744C232.554 263.966 234.657 262.822 237.019 262.856C239.618 262.892 241.865 264.345 243.036 266.468C241.662 268.083 239.605 269.096 237.319 269.064C234.782 269.028 232.563 267.714 231.266 265.744Z",
    fill: "#B75854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.266 265.743L230.517 265.201L230.142 265.718L230.494 266.252L231.266 265.743ZM243.036 266.468L243.74 267.067L244.154 266.581L243.845 266.022L243.036 266.468ZM232.014 266.286C233.133 264.742 234.958 263.751 237.006 263.78L237.032 261.931C234.357 261.894 231.974 263.19 230.517 265.201L232.014 266.286ZM237.006 263.78C239.259 263.812 241.209 265.07 242.226 266.915L243.845 266.022C242.52 263.619 239.976 261.973 237.032 261.931L237.006 263.78ZM242.332 265.869C241.129 267.283 239.331 268.167 237.332 268.139L237.306 269.988C239.879 270.024 242.195 268.883 243.74 267.067L242.332 265.869ZM237.332 268.139C235.115 268.108 233.174 266.961 232.038 265.235L230.494 266.252C231.952 268.467 234.45 269.948 237.306 269.988L237.332 268.139Z",
    fill: "black",
    mask: "url(#path-105-inside-1_47_3046)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-107-inside-2_47_3046",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.922 371.744C292.21 369.966 294.313 368.822 296.675 368.856C299.274 368.892 301.521 370.345 302.692 372.468C301.318 374.083 299.261 375.096 296.975 375.064C294.438 375.028 292.219 373.714 290.922 371.744Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M290.922 371.744C292.21 369.966 294.313 368.822 296.675 368.856C299.274 368.892 301.521 370.345 302.692 372.468C301.318 374.083 299.261 375.096 296.975 375.064C294.438 375.028 292.219 373.714 290.922 371.744Z",
    fill: "#B75854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.922 371.743L290.173 371.201L289.798 371.718L290.15 372.252L290.922 371.743ZM302.692 372.468L303.396 373.067L303.81 372.581L303.501 372.022L302.692 372.468ZM291.67 372.286C292.789 370.742 294.614 369.751 296.662 369.78L296.688 367.931C294.013 367.894 291.63 369.19 290.173 371.201L291.67 372.286ZM296.662 369.78C298.915 369.812 300.865 371.07 301.882 372.915L303.501 372.022C302.176 369.619 299.632 367.973 296.688 367.931L296.662 369.78ZM301.988 371.869C300.785 373.283 298.987 374.167 296.988 374.139L296.962 375.988C299.535 376.024 301.851 374.883 303.396 373.067L301.988 371.869ZM296.988 374.139C294.771 374.108 292.83 372.961 291.694 371.235L290.15 372.252C291.608 374.467 294.106 375.948 296.962 375.988L296.988 374.139Z",
    fill: "black",
    mask: "url(#path-107-inside-2_47_3046)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-109-inside-3_47_3046",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.922 371.744C174.21 369.966 176.313 368.822 178.675 368.856C181.274 368.892 183.521 370.345 184.692 372.468C183.318 374.083 181.261 375.096 178.975 375.064C176.438 375.028 174.219 373.714 172.922 371.744Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M172.922 371.744C174.21 369.966 176.313 368.822 178.675 368.856C181.274 368.892 183.521 370.345 184.692 372.468C183.318 374.083 181.261 375.096 178.975 375.064C176.438 375.028 174.219 373.714 172.922 371.744Z",
    fill: "#B75854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.922 371.743L172.173 371.201L171.798 371.718L172.15 372.252L172.922 371.743ZM184.692 372.468L185.396 373.067L185.81 372.581L185.501 372.022L184.692 372.468ZM173.67 372.286C174.789 370.742 176.614 369.751 178.662 369.78L178.688 367.931C176.013 367.894 173.63 369.19 172.173 371.201L173.67 372.286ZM178.662 369.78C180.915 369.812 182.865 371.07 183.882 372.915L185.501 372.022C184.176 369.619 181.632 367.973 178.688 367.931L178.662 369.78ZM183.988 371.869C182.785 373.283 180.987 374.167 178.988 374.139L178.962 375.988C181.535 376.024 183.851 374.883 185.396 373.067L183.988 371.869ZM178.988 374.139C176.771 374.108 174.83 372.961 173.694 371.235L172.15 372.252C173.608 374.467 176.106 375.948 178.962 375.988L178.988 374.139Z",
    fill: "black",
    mask: "url(#path-109-inside-3_47_3046)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-111-inside-4_47_3046",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.922 266.744C120.21 264.966 122.313 263.822 124.675 263.856C127.274 263.892 129.521 265.345 130.692 267.468C129.318 269.083 127.261 270.096 124.975 270.064C122.438 270.028 120.219 268.714 118.922 266.744Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M118.922 266.744C120.21 264.966 122.313 263.822 124.675 263.856C127.274 263.892 129.521 265.345 130.692 267.468C129.318 269.083 127.261 270.096 124.975 270.064C122.438 270.028 120.219 268.714 118.922 266.744Z",
    fill: "#B75854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.922 266.743L118.173 266.201L117.798 266.718L118.15 267.252L118.922 266.743ZM130.692 267.468L131.396 268.067L131.81 267.581L131.501 267.022L130.692 267.468ZM119.67 267.286C120.789 265.742 122.614 264.751 124.662 264.78L124.688 262.931C122.013 262.894 119.63 264.19 118.173 266.201L119.67 267.286ZM124.662 264.78C126.915 264.812 128.865 266.07 129.882 267.915L131.501 267.022C130.176 264.619 127.632 262.973 124.688 262.931L124.662 264.78ZM129.988 266.869C128.785 268.283 126.987 269.167 124.988 269.139L124.962 270.988C127.535 271.024 129.851 269.883 131.396 268.067L129.988 266.869ZM124.988 269.139C122.771 269.108 120.83 267.961 119.694 266.235L118.15 267.252C119.608 269.467 122.106 270.948 124.962 270.988L124.988 269.139Z",
    fill: "black",
    mask: "url(#path-111-inside-4_47_3046)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-113-inside-5_47_3046",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9217 370.744C55.2095 368.966 57.3135 367.822 59.6749 367.856C62.2737 367.892 64.5206 369.345 65.692 371.468C64.318 373.083 62.2609 374.096 59.9751 374.064C57.4383 374.028 55.2191 372.714 53.9217 370.744Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.9217 370.744C55.2095 368.966 57.3135 367.822 59.6749 367.856C62.2737 367.892 64.5206 369.345 65.692 371.468C64.318 373.083 62.2609 374.096 59.9751 374.064C57.4383 374.028 55.2191 372.714 53.9217 370.744Z",
    fill: "#B75854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9217 370.743L53.1731 370.201L52.7983 370.718L53.1496 371.252L53.9217 370.743ZM65.692 371.468L66.3961 372.067L66.8099 371.581L66.5015 371.022L65.692 371.468ZM54.6703 371.286C55.7891 369.742 57.6141 368.751 59.662 368.78L59.6879 366.931C57.0129 366.894 54.6299 368.19 53.1731 370.201L54.6703 371.286ZM59.662 368.78C61.9152 368.812 63.865 370.07 64.8825 371.915L66.5015 371.022C65.1763 368.619 62.6321 366.973 59.6879 366.931L59.662 368.78ZM64.9879 370.869C63.7849 372.283 61.9867 373.167 59.9881 373.139L59.9622 374.988C62.535 375.024 64.8512 373.883 66.3961 372.067L64.9879 370.869ZM59.9881 373.139C57.7705 373.108 55.8299 371.961 54.6938 370.235L53.1496 371.252C54.6082 373.467 57.1061 374.948 59.9622 374.988L59.9881 373.139Z",
    fill: "black",
    mask: "url(#path-113-inside-5_47_3046)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-115-inside-6_47_3046",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.922 137.744C181.21 135.966 183.313 134.822 185.675 134.856C188.274 134.892 190.521 136.345 191.692 138.468C190.318 140.083 188.261 141.096 185.975 141.064C183.438 141.028 181.219 139.714 179.922 137.744Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.922 137.744C181.21 135.966 183.313 134.822 185.675 134.856C188.274 134.892 190.521 136.345 191.692 138.468C190.318 140.083 188.261 141.096 185.975 141.064C183.438 141.028 181.219 139.714 179.922 137.744Z",
    fill: "#B75854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.922 137.743L179.173 137.201L178.798 137.718L179.15 138.252L179.922 137.743ZM191.692 138.468L192.396 139.067L192.81 138.581L192.501 138.022L191.692 138.468ZM180.67 138.286C181.789 136.742 183.614 135.751 185.662 135.78L185.688 133.931C183.013 133.894 180.63 135.19 179.173 137.201L180.67 138.286ZM185.662 135.78C187.915 135.812 189.865 137.07 190.882 138.915L192.501 138.022C191.176 135.619 188.632 133.973 185.688 133.931L185.662 135.78ZM190.988 137.869C189.785 139.283 187.987 140.167 185.988 140.139L185.962 141.988C188.535 142.024 190.851 140.883 192.396 139.067L190.988 137.869ZM185.988 140.139C183.771 140.108 181.83 138.961 180.694 137.235L179.15 138.252C180.608 140.467 183.106 141.948 185.962 141.988L185.988 140.139Z",
    fill: "black",
    mask: "url(#path-115-inside-6_47_3046)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-117-inside-7_47_3046",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.266 265.744C259.554 263.966 261.657 262.822 264.019 262.856C266.618 262.892 268.865 264.345 270.036 266.468C268.662 268.083 266.605 269.096 264.319 269.064C261.782 269.028 259.563 267.714 258.266 265.744Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.266 265.744C259.554 263.966 261.657 262.822 264.019 262.856C266.618 262.892 268.865 264.345 270.036 266.468C268.662 268.083 266.605 269.096 264.319 269.064C261.782 269.028 259.563 267.714 258.266 265.744Z",
    fill: "#B75854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.266 265.743L257.517 265.201L257.142 265.718L257.494 266.252L258.266 265.743ZM270.036 266.468L270.74 267.067L271.154 266.581L270.845 266.022L270.036 266.468ZM259.014 266.286C260.133 264.742 261.958 263.751 264.006 263.78L264.032 261.931C261.357 261.894 258.974 263.19 257.517 265.201L259.014 266.286ZM264.006 263.78C266.259 263.812 268.209 265.07 269.226 266.915L270.845 266.022C269.52 263.619 266.976 261.973 264.032 261.931L264.006 263.78ZM269.332 265.869C268.129 267.283 266.331 268.167 264.332 268.139L264.306 269.988C266.879 270.024 269.195 268.883 270.74 267.067L269.332 265.869ZM264.332 268.139C262.115 268.108 260.174 266.961 259.038 265.235L257.494 266.252C258.952 268.467 261.45 269.948 264.306 269.988L264.332 268.139Z",
    fill: "black",
    mask: "url(#path-117-inside-7_47_3046)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-119-inside-8_47_3046",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.922 371.744C319.21 369.966 321.313 368.822 323.675 368.856C326.274 368.892 328.521 370.345 329.692 372.468C328.318 374.083 326.261 375.096 323.975 375.064C321.438 375.028 319.219 373.714 317.922 371.744Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M317.922 371.744C319.21 369.966 321.313 368.822 323.675 368.856C326.274 368.892 328.521 370.345 329.692 372.468C328.318 374.083 326.261 375.096 323.975 375.064C321.438 375.028 319.219 373.714 317.922 371.744Z",
    fill: "#B75854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.922 371.743L317.173 371.201L316.798 371.718L317.15 372.252L317.922 371.743ZM329.692 372.468L330.396 373.067L330.81 372.581L330.501 372.022L329.692 372.468ZM318.67 372.286C319.789 370.742 321.614 369.751 323.662 369.78L323.688 367.931C321.013 367.894 318.63 369.19 317.173 371.201L318.67 372.286ZM323.662 369.78C325.915 369.812 327.865 371.07 328.882 372.915L330.501 372.022C329.176 369.619 326.632 367.973 323.688 367.931L323.662 369.78ZM328.988 371.869C327.785 373.283 325.987 374.167 323.988 374.139L323.962 375.988C326.535 376.024 328.851 374.883 330.396 373.067L328.988 371.869ZM323.988 374.139C321.771 374.108 319.83 372.961 318.694 371.235L317.15 372.252C318.608 374.467 321.106 375.948 323.962 375.988L323.988 374.139Z",
    fill: "black",
    mask: "url(#path-119-inside-8_47_3046)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-121-inside-9_47_3046",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.922 371.744C201.21 369.966 203.313 368.822 205.675 368.856C208.274 368.892 210.521 370.345 211.692 372.468C210.318 374.083 208.261 375.096 205.975 375.064C203.438 375.028 201.219 373.714 199.922 371.744Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.922 371.744C201.21 369.966 203.313 368.822 205.675 368.856C208.274 368.892 210.521 370.345 211.692 372.468C210.318 374.083 208.261 375.096 205.975 375.064C203.438 375.028 201.219 373.714 199.922 371.744Z",
    fill: "#B75854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.922 371.743L199.173 371.201L198.798 371.718L199.15 372.252L199.922 371.743ZM211.692 372.468L212.396 373.067L212.81 372.581L212.501 372.022L211.692 372.468ZM200.67 372.286C201.789 370.742 203.614 369.751 205.662 369.78L205.688 367.931C203.013 367.894 200.63 369.19 199.173 371.201L200.67 372.286ZM205.662 369.78C207.915 369.812 209.865 371.07 210.882 372.915L212.501 372.022C211.176 369.619 208.632 367.973 205.688 367.931L205.662 369.78ZM210.988 371.869C209.785 373.283 207.987 374.167 205.988 374.139L205.962 375.988C208.535 376.024 210.851 374.883 212.396 373.067L210.988 371.869ZM205.988 374.139C203.771 374.108 201.83 372.961 200.694 371.235L199.15 372.252C200.608 374.467 203.106 375.948 205.962 375.988L205.988 374.139Z",
    fill: "black",
    mask: "url(#path-121-inside-9_47_3046)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-123-inside-10_47_3046",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.922 266.744C147.21 264.966 149.313 263.822 151.675 263.856C154.274 263.892 156.521 265.345 157.692 267.468C156.318 269.083 154.261 270.096 151.975 270.064C149.438 270.028 147.219 268.714 145.922 266.744Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.922 266.744C147.21 264.966 149.313 263.822 151.675 263.856C154.274 263.892 156.521 265.345 157.692 267.468C156.318 269.083 154.261 270.096 151.975 270.064C149.438 270.028 147.219 268.714 145.922 266.744Z",
    fill: "#B75854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.922 266.743L145.173 266.201L144.798 266.718L145.15 267.252L145.922 266.743ZM157.692 267.468L158.396 268.067L158.81 267.581L158.501 267.022L157.692 267.468ZM146.67 267.286C147.789 265.742 149.614 264.751 151.662 264.78L151.688 262.931C149.013 262.894 146.63 264.19 145.173 266.201L146.67 267.286ZM151.662 264.78C153.915 264.812 155.865 266.07 156.882 267.915L158.501 267.022C157.176 264.619 154.632 262.973 151.688 262.931L151.662 264.78ZM156.988 266.869C155.785 268.283 153.987 269.167 151.988 269.139L151.962 270.988C154.535 271.024 156.851 269.883 158.396 268.067L156.988 266.869ZM151.988 269.139C149.771 269.108 147.83 267.961 146.694 266.235L145.15 267.252C146.608 269.467 149.106 270.948 151.962 270.988L151.988 269.139Z",
    fill: "black",
    mask: "url(#path-123-inside-10_47_3046)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-125-inside-11_47_3046",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.9217 370.744C82.2095 368.966 84.3135 367.822 86.6749 367.856C89.2737 367.892 91.5206 369.345 92.692 371.468C91.318 373.083 89.2609 374.096 86.9751 374.064C84.4383 374.028 82.2191 372.714 80.9217 370.744Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.9217 370.744C82.2095 368.966 84.3135 367.822 86.6749 367.856C89.2737 367.892 91.5206 369.345 92.692 371.468C91.318 373.083 89.2609 374.096 86.9751 374.064C84.4383 374.028 82.2191 372.714 80.9217 370.744Z",
    fill: "#B75854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9217 370.743L80.1731 370.201L79.7983 370.718L80.1496 371.252L80.9217 370.743ZM92.692 371.468L93.3961 372.067L93.8099 371.581L93.5015 371.022L92.692 371.468ZM81.6703 371.286C82.7891 369.742 84.6141 368.751 86.662 368.78L86.6879 366.931C84.0129 366.894 81.6299 368.19 80.1731 370.201L81.6703 371.286ZM86.662 368.78C88.9152 368.812 90.865 370.07 91.8825 371.915L93.5015 371.022C92.1763 368.619 89.6321 366.973 86.6879 366.931L86.662 368.78ZM91.9879 370.869C90.7849 372.283 88.9867 373.167 86.9881 373.139L86.9622 374.988C89.535 375.024 91.8512 373.883 93.3961 372.067L91.9879 370.869ZM86.9881 373.139C84.7705 373.108 82.8299 371.961 81.6938 370.235L80.1496 371.252C81.6082 373.467 84.1061 374.948 86.9622 374.988L86.9881 373.139Z",
    fill: "black",
    mask: "url(#path-125-inside-11_47_3046)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-127-inside-12_47_3046",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.922 137.744C208.21 135.966 210.313 134.822 212.675 134.856C215.274 134.892 217.521 136.345 218.692 138.468C217.318 140.083 215.261 141.096 212.975 141.064C210.438 141.028 208.219 139.714 206.922 137.744Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M206.922 137.744C208.21 135.966 210.313 134.822 212.675 134.856C215.274 134.892 217.521 136.345 218.692 138.468C217.318 140.083 215.261 141.096 212.975 141.064C210.438 141.028 208.219 139.714 206.922 137.744Z",
    fill: "#B75854"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.922 137.743L206.173 137.201L205.798 137.718L206.15 138.252L206.922 137.743ZM218.692 138.468L219.396 139.067L219.81 138.581L219.501 138.022L218.692 138.468ZM207.67 138.286C208.789 136.742 210.614 135.751 212.662 135.78L212.688 133.931C210.013 133.894 207.63 135.19 206.173 137.201L207.67 138.286ZM212.662 135.78C214.915 135.812 216.865 137.07 217.882 138.915L219.501 138.022C218.176 135.619 215.632 133.973 212.688 133.931L212.662 135.78ZM217.988 137.869C216.785 139.283 214.987 140.167 212.988 140.139L212.962 141.988C215.535 142.024 217.851 140.883 219.396 139.067L217.988 137.869ZM212.988 140.139C210.771 140.108 208.83 138.961 207.694 137.235L206.15 138.252C207.608 140.467 210.106 141.948 212.962 141.988L212.988 140.139Z",
    fill: "black",
    mask: "url(#path-127-inside-12_47_3046)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.739 469.565H30.5652L28.6086 531.522H144.696L142.739 469.565Z",
    fill: "#CF3E39"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 63.8259,
    y: 472.174,
    width: 11.7391,
    height: 60,
    fill: "#FFD04D"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 460.435,
    width: 11.7391,
    height: 120,
    transform: "rotate(90 146 460.435)",
    fill: "#1AE0AC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.9131,
    y: 494.348,
    width: 113.478,
    height: 2.6087,
    fill: "#FFD04D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.9182 460.368L82.5138 429.539L96.0028 437.794L72.9182 460.368Z",
    fill: "#1AE0AC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2078 460.106L55.0686 451.357L74.7795 440.028L73.2078 460.106Z",
    fill: "#1AE0AC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.428,
    y: 120,
    width: 4.92857,
    height: 36.1429,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.286,
    y: 120,
    width: 11.5,
    height: 29.5714,
    transform: "rotate(90 344.286 120)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 120,
    width: 4.92857,
    height: 36.1429,
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 305.679,
    cy: 156.964,
    rx: 10.6786,
    ry: 9.03571,
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 335.25,
    cy: 156.964,
    rx: 10.6786,
    ry: 9.03571,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.4285,
    y: 199,
    width: 4.92857,
    height: 36.1429,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 199,
    width: 12,
    height: 20,
    transform: "rotate(90 81 199)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.6786,
    cy: 235.964,
    rx: 10.6786,
    ry: 9.03571,
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_47_3046",
    x1: 195,
    y1: 642,
    x2: 195,
    y2: 365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#13410B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1E4717",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_3046"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 615,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFamily);
export default __webpack_public_path__ + "static/media/family.b0414cc4bf30a3d744b47f2c3704524a.svg";
export { ForwardRef as ReactComponent };